import { render, staticRenderFns } from "./salonParticipant.vue?vue&type=template&id=65983811&scoped=true&"
import script from "./salonParticipant.vue?vue&type=script&lang=js&"
export * from "./salonParticipant.vue?vue&type=script&lang=js&"
import style0 from "./salonParticipant.vue?vue&type=style&index=0&id=65983811&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65983811",
  null
  
)

export default component.exports